import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { navigate } from 'gatsby'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	Stitch,
	RemoteMongoClient,
	UserApiKeyCredential,
} from 'mongodb-stitch-browser-sdk'
import BSON from 'mongodb-stitch-bson'
import DatePicker from 'react-datepicker'
import moment from 'moment'

const FormSchema = Yup.object().shape({
	date: Yup.string().required('Required'),
})

function validationIcons(valid) {
	return valid ? (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="exclamation-triangle" />
		</span>
	) : (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="check" />
		</span>
	)
}

class BookingSuccess extends Component {
	constructor(props) {
		super(props)
		this.state = {
			mongoDBStatus: '',
		}
	}

	componentDidMount() {
		if (!Stitch.hasAppClient('book-a-demo-hcaug')) {
			this.client = Stitch.initializeDefaultAppClient('book-a-demo-hcaug')
		} else {
			this.client = Stitch.defaultAppClient
		}
		this.db = this.client
			.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas')
			.db('bookings')
	}

	render() {
		const { params, formName } = this.props
		return (
			<Formik
				initialValues={{
					date: '',
				}}
				validationSchema={FormSchema}
				onSubmit={(values, { setSubmitting, setStatus, resetForm }) => {
					const dateTime = moment(values.date).format('LLLL')
					setSubmitting(true)
					if (!/^[0-9a-fA-F]{24}$/.test(params.id)) {
						return (
							this.setState({
								mongoDBStatus: `Unique Lead ID is invalid, please check your lead email and try again`,
							}),
							setSubmitting(false),
							setStatus('failure')
						)
					}
					this.client.auth
						.loginWithCredential(
							new UserApiKeyCredential(process.env.GATSBY_MONGODB)
						)
						.then(
							res => {
								this.setState({
									mongoDBStatus: `MongoDB API - logged in as user: ${
										res.id
									}\n${res}`,
								})
								this.db
									.collection('leads')
									.updateOne(
										{ _id: BSON.ObjectId(params.id) },
										{
											$set: {
												bookingDateTime: dateTime,
												bookingStatus: 'confirmed',
												leadStatus: 'open',
											},
										}
									)
									.then(
										res => {
											this.setState({
												mongoDBStatus: `MongoDB API PUT is Good:\n${res}`,
											})
											this.client
												.callFunction('bookingSuccess', [params.id])
												.then(res => {
													this.setState({
														mongoDBStatus: `MongoDB API CALL is Good:\n${res}`,
													})
													setSubmitting(false)
													resetForm()
													navigate('/successful-booking?form=booking-success')
													setStatus('success')
												})
												.catch(err => {
													this.setState({
														mongoDBStatus: `MongoDB API CALL is Bad: ${
															err.message
														}\n${err}`,
													})
													setSubmitting(false)
													setStatus('failure')
												})
										},
										err => {
											this.setState({
												mongoDBStatus: `MongoDB API CALL is Bad: ${
													err.message
												}\n${err}`,
											})
											setSubmitting(false)
											setStatus('failure')
										}
									)
									.catch(err => {
										this.setState({
											mongoDBStatus: `MongoDB API PUT is Bad: ${
												err.message
											}\n${err}`,
										})
										setSubmitting(false)
										setStatus('failure')
									})
							},
							err => {
								this.setState({
									mongoDBStatus: `MongoDB API Auth is bad: ${
										err.message
									}\n${err}`,
								})
								setSubmitting(false)
								setStatus('failure')
							}
						)
				}}
				render={({
					values,
					errors,
					touched,
					handleSubmit,
					isSubmitting,
					setStatus,
					status,
					setFieldValue,
					setFieldTouched,
				}) => (
					<form
						name={formName}
						method="post"
						data-netlify="true"
						data-netlify-honeypot="bot-field"
						onSubmit={handleSubmit}
						className="form"
					>
						<input type="hidden" name="form-name" defaultValue={formName} />
						<div className="field is-horizontal">
							<div className="field-label">
								<label className="label" htmlFor="date">
									Confirmed Time
								</label>
							</div>
							<div className="field-body">
								<div className="field is-expanded" aria-describedby="date">
									<div className="control has-icons-left has-icons-right">
										<DatePicker
											id="booking-date"
											type="date"
											selected={values.date ? moment(values.date) : null}
											onChange={date => setFieldValue('date', date)}
											onBlur={blur => setFieldTouched('date', blur)}
											showTimeSelect
											minTime={moment()
												.hours(8)
												.minutes(0)}
											maxTime={moment()
												.hours(17)
												.minutes(0)}
											minDate={moment()}
											maxDate={moment().add(2, 'months')}
											timeIntervals={120}
											filterDate={date => {
												const day = date.day()
												return day !== 0
											}}
											showDisabledMonthNavigation
											utcOffset={+10}
											locale="en-au"
											dateFormat="DD/MM/YYYY, h:mma"
											className={classNames(
												touched.date && errors.date && `is-danger`,
												values.date && !errors.date && `is-success`,
												`input`
											)}
											placeholderText="Booking Date and Time"
											required={true}
										/>
										<span className="icon is-small is-left">
											<FontAwesomeIcon icon="calendar-alt" />
										</span>
										{touched.date && errors.date && validationIcons(true)}
										{values.date && !errors.date && validationIcons(false)}
									</div>
									{touched.date && errors.date && (
										<p className="help is-danger" id="date-helper-text">
											{errors.date}
										</p>
									)}
								</div>
							</div>
						</div>
						<p className="has-text-centered">
							<button
								type="submit"
								disabled={isSubmitting}
								className={classNames(
									isSubmitting && `is-loading`,
									`button is-warning is-medium`
								)}
							>
								Submit
							</button>
						</p>
						<div
							className={status === 'success' ? `is-active modal` : `modal`}
							id="form-success"
						>
							<div className="modal-background" onClick={() => setStatus('')}>
								<div className="before" />
								<div className="after" />
							</div>
							<div className="modal-content">
								<div className="box">
									<div className="content">
										<h1>You have confirmed the booking! 😄</h1>
										<p>Thanks for taking the time confirm the booking.</p>
									</div>
								</div>
							</div>
							<button
								className="modal-close is-large"
								aria-label="close"
								onClick={() => setStatus('')}
							/>
						</div>
						<div
							className={status === 'failure' ? `is-active modal` : `modal`}
							id="form-failure"
						>
							<div className="modal-background" onClick={() => setStatus('')} />
							<div className="modal-content">
								<div className="box">
									<div className="content">
										<h1>Something went wrong 😞</h1>
										<p>
											Form is invalid, please check your details and try again.
										</p>
										<pre>{this.state.mongoDBStatus}</pre>
									</div>
								</div>
							</div>
							<button
								className="modal-close is-large"
								aria-label="close"
								onClick={() => setStatus('')}
							/>
						</div>
					</form>
				)}
			/>
		)
	}
}

BookingSuccess.propTypes = {
	formName: PropTypes.string,
	params: PropTypes.object,
}

export default BookingSuccess
